import axios from 'axios';
import config from 'config';
import type { GuestCustomer } from './GuestAuthContext';

const guestHttp = axios.create({ baseURL: config.api.base });

export async function requestMagicLink(email: string, fullName: string, language: string): Promise<{ message: string }> {
    const { data } = await guestHttp.post(config.api.magicLinkRequest, { email, fullName, language });
    return data;
}

export async function verifyMagicLink(token: string): Promise<{ accessToken: string; customer: GuestCustomer }> {
    const { data } = await guestHttp.post(config.api.magicLinkVerify, { token });
    return data;
}

export type AssessmentReportStatus = 'submitted' | 'reply_received' | 'completed' | null;

export interface GuestDocument {
    id: string;
    queueType: string;
    originalDocumentUrl: string;
    analysisDocumentUrl: string | null;
    analysisText: string | null;
    status: 'uploaded' | 'processing' | 'analysed' | 'completed';
    assessmentReportStatus: AssessmentReportStatus;
    caseNumber: string | null;
    createdAt: string;
    updatedAt: string;
}

export async function fetchGuestDocuments(accessToken: string): Promise<GuestDocument[]> {
    const { data } = await guestHttp.get<{ documents: GuestDocument[] }>(config.api.guestDocuments, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    return data.documents;
}

export interface AssessmentReportReplyAttachment {
    id: string;
    fileName: string;
    contentType: string | null;
    sizeBytes: number | null;
    url: string;
}

export interface AssessmentReportReply {
    id: string;
    fromAddress: string;
    subject: string;
    bodyText: string | null;
    bodyHtml: string | null;
    receivedAt: string;
    attachments: AssessmentReportReplyAttachment[];
}

export interface AssessmentReportRepliesResponse {
    documentId: string;
    assessmentReportStatus: AssessmentReportStatus;
    replies: AssessmentReportReply[];
}

export async function fetchAssessmentReportReplies(
    accessToken: string,
    documentId: string,
): Promise<AssessmentReportRepliesResponse> {
    const { data } = await guestHttp.get<AssessmentReportRepliesResponse>(
        `${config.api.guestAssessmentReportReplies}/${documentId}/replies`,
        { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    return data;
}
